var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCcw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.844 6.205A8.333 8.333 0 008.12 8.433l-2.453 2.305V7.665a.833.833 0 10-1.667 0v5c0 .46.373.834.833.834h5a.833.833 0 100-1.667H6.936l2.335-2.193a6.666 6.666 0 0111.019 2.47.833.833 0 001.57-.556 8.333 8.333 0 00-6.016-5.348zm7.901 9.193a.83.83 0 01.255.6v5a.833.833 0 11-1.666 0v-3.074L19.88 20.23a8.333 8.333 0 01-13.74-3.12.833.833 0 111.57-.557 6.666 6.666 0 0011 2.489l.012-.011.007-.007 2.333-2.192h-2.895a.833.833 0 010-1.667h4.972a.831.831 0 01.606.233z"
  })));
}
export default SvgRefreshCcw;